<template>
    <!-- 项目详情 -->
    <div class="project-detail">
        <div class="banner">
            <div class="banner-inner">
                <h2 class="title">美育共同体</h2>
                <p class="subtitle">——王海燕 教师发展中心主持</p>
            </div>
        </div>
        <div class="detail-info flex-layout">
            <div class="img-warp">
                <img src="../../assets/studio/image-1.png" alt="" class="host-image">
                <p class="img-text">负责人：<br>王海燕——教师发展中心/思想政治教师</p>
            </div>
            <div class="desc-warp">
                <p class="desc-title">美育共同体</p>
                <div class="text">
                    <p class="section">
                        在大中小一体化数字美育双反哺教学实践共同体建设中，充分发挥主体间的统筹协调和美育资源的有效整合，明确各主体职责，从纵向链接、横向贯通，凝聚合力意识，促进共同体建设。发挥评价指挥棒的作用，健全大中小学美育一体化评价体系，构建多元、立体、全过程的评价体系，对美育资源、学生学业、学校美育建设等方面作出评价指导，建立动态监测、反馈指导机制、优化推广机制，精准高效推进美育一体化发展。
                    </p>
                    <p class="section">
                        在大中小一体化数字美育双反哺教学实践共同体建设中，充分发挥主体间的统筹协调和美育资源的有效整合，明确各主体职责，从纵向链接、横向贯通，凝聚合力意识，促进共同体建设。发挥评价指挥棒的作用，健全大中小学美育一体化评价体系，构建多元、立体、全过程的评价体系，对美育资源、学生学业、学校美育建设等方面作出评价指导，建立动态监测、反馈指导机制、优化推广机制，精准高效推进美育一体化发展。
                    </p>
                </div>
            </div>
        </div>
        <div class="result-inner">
            <h4 class="result-title">成果展示</h4>
            <ul class="result-list flex-layout">
                <li class="result-item" v-for="(item,index) in 5" :key="index">
                    <img src="" alt="" class="result-img">
                    <p class="result-desc wes-2">首都师范大学“双优云桥·首师优字”项目入选教育部“经典润乡土计划”重点项目</p>
                    <p class="result-time">2022年9月</p>
                </li>
            </ul>
            <!-- <pagination v-show="pages.total > 0" :total="pages.total" :page.sync="pages.currentPage" :small="true"
                :limit.sync="pages.pageSize" :pageSizes="[8,16,24]" :layout="'prev,pager,next'"
                @pagination="handlePageChange">
            </pagination> -->
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeMenu: 0,
                menuList: [{
                        name: '全部',
                    },
                    {
                        name: '区域',
                    },
                    {
                        name: '学校',
                    },
                    {
                        name: '其他',
                    },
                ],
                pages: { //分页
                    currentPage: 1,
                    pageSize: 8,
                    total: 100,
                },
            }
        },
        methods: {
            chooseMenu(index) {
                this.activeMenu = index;
            },
        }
    }
</script>

<style lang="less" scoped>
    .project-detail {
        .banner {
            background-image: url("../../assets/studio/project-banner.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            height: 56vh;
            max-height: 530px;
            min-height: 360px;

            position: relative;

            .banner-inner {
                position: absolute;
                width: 100%;
                top: 25%;
            }

            .title {
                margin-bottom: 2.2%;
                padding-left: 20%;
                color: #0b0b0b;
                font-size: 101px;
                font-weight: bold;
                letter-spacing: 2px;
            }

            .subtitle {
                color: #0b0b0b;
                font-size: 48px;
                font-weight: bold;
                letter-spacing: 2px;
                text-align: center;

            }
        }

        .detail-info {
            padding: 7% 5.2%;

            .img-warp {
                width: 575px;
                height: 616px;
                margin-right: 169px;
                position: relative;
                flex-shrink: 0;

                &::before {
                    content: ' ';
                    width: 209px;
                    height: 10px;
                    display: inline-block;
                    position: absolute;
                    top: -10px;
                    left: 0;
                    background-color: #2c79ff;
                }


                &::after {
                    content: ' ';
                    width: 472px;
                    height: 466px;
                    display: inline-block;
                    position: absolute;
                    bottom: -70px;
                    right: -77px;
                    background-image: url("../../assets/studio/image-4.png");
                    z-index: 1;
                }


                .host-image {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    z-index: 2;
                }

                .img-text {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    background-color: rgba(126, 107, 90, .71);
                    color: #fff;
                    font-size: 24px;
                    line-height: 2;
                    padding: 37px 56px 54px;
                    box-sizing: border-box;
                    z-index: 3;
                }
            }

            .desc-title {
                font-size: 36px;
                margin-bottom: 60px;
            }

            .section {
                font-size: 24px;
                line-height: 2;
                text-indent: 2em;
                margin-bottom: 15px;
                font-weight: 300;
            }
        }



        .result-inner {
            background-image: url("../../assets/business/bg.png");
            background-position: bottom;
            background-repeat: no-repeat;
            padding: 3.5% 5.2% 50%;

            .result-title {
                font-size: 36px;
                text-align: center;
                margin-bottom: 4.5%;
            }

            .result-list {
                flex-wrap: wrap;
            }


            .result-item {
                margin-right: 4.4%;
                margin-bottom: 4.2%;
                width: calc((100% - 4.8% * 2) / 3);
                border: 1px solid #d2d2d2;
                transition: 1s all;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                &:hover {
                    box-shadow: 0px 2px 35px 2px rgba(30, 19, 15, 0.11);
                }
            }

            .result-img {
                width: 100%;
                height: 330px;
            }

            .result-desc {
                padding: 4% 5% 4%;
                font-size: 22px;
                font-weight: 300;
                line-height: 1.6;
            }

            .result-time {
                text-align: right;
                font-size: 16px;
                color: #666;
                font-weight: 300;
                padding: 0 5% 4%;
            }


        }



        @media screen and (max-width:1850px) {
            .banner {

                .title {
                    font-size: 40px;
                }


                .menu-item {
                    font-size: 25px;
                }
            }

            .case-inner {
                .case-img {
                    height: 298px;
                }


                .case-title {
                    font-size: 25px;

                    &::before {
                        margin: 0 10px;
                    }
                }


                .case-desc {
                    font-size: 17px;
                }

                .case-info {
                    font-size: 13px;
                }


            }

        }

        @media screen and (max-width:1450px) {
            .banner {

                .title {
                    font-size: 31px;
                }


                .menu-item {
                    font-size: 20px;
                }
            }

            .case-inner {
                .case-img {
                    height: 232px;
                }


                .case-title {
                    font-size: 20px;
                    border-top-right-radius: 8px;
                    border-bottom-right-radius: 8px;

                    &::before {
                        margin: 0 10px;
                        width: 14px;
                        height: 14px;
                    }
                }


                .case-desc {
                    font-size: 15px;
                }

                .case-info {
                    font-size: 12px;
                }


            }
        }

        @media screen and (max-width:1150px) {
            .case-inner {
                .case-title {
                    font-size: 20px;

                }

            }
        }
    }
</style>